export enum ImageDownloaderVariants {
  Button = "button",
  ListItem = "listItem",
}

export enum Messaging {
  UserInput = 'Invalid name. Please dont use these characters: <,>,:,",/,\\,|,?,*',
  NullDate = "Date must not be empty",
}
